// extracted by mini-css-extract-plugin
export default {"title":"OWjoVdVGuXMC9k6d5NiD","placeHolderShimmer":"LIecDPSq7wUv3kMBclZb"};